import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import Calculator from 'app/theme/calculator'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import heroImg from 'assets/img/business-lunch-hero.jpg'
import lunchCatering1 from 'assets/img/businesslunch-catering-1.jpg'
import lunchCatering2 from 'assets/img/businesslunch-catering-2.jpg'
import lunchCatering3 from 'assets/img/businesslunch-catering-3.jpg'
import lunchCatering4 from 'assets/img/businesslunch-catering-4.jpg'
import LeadModal from 'app/leads/LeadModal'
import getGoogleMetaTags from './occasionSEOData'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import { useInView } from 'react-intersection-observer'


export default function BusinessLunchCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  const googleMetaTags = getGoogleMetaTags('businessLunchCatering')


  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Business Lunch Catering (Best Corporate Caterers) - Roaming Hunger</title>
        <meta name="og:title" content="Business Lunch Catering (Best Corporate Caterers)"></meta>
        <meta name="description" content="We make catering business lunches easy. From buffet style to prepackaged meals, work with a dedicated agent to get delicious lunch catering options that fit your office."></meta>
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Business Lunch Catering"
          onButtonClick={openModal}
          description={(
            <div>
              Get the best lunch catering for your business. Whether you need to stay productive or take a break, we'll find you the best catering options to make your office lunch delicious.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <IntroContent />
      <IntroGrid />
      <WhyWorkWithUs
        onButtonClick={openModal}
      />
      <WhyWorkWithUsGrid />
      <HowItWorks
        heading="How Business Lunch Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Business Lunch Catering Works"
        onButtonClick={openModal}
      />
      <FeaturedClients
        onButtonClick={openModal}
      />
      <Calculator
        heading="How Much Does Business Lunch Catering Cost?"
        onButtonClick={openModal}
      />
      <OccasionsSlider
        className="bg-white py-12"
      />
    </Layout>
  )
}

function IntroContent() {
  return (
    <div className="container text-center py-12 px-8">
      <h2 className="text-navy text-4xl leading-tight font-platform">
        When it comes to lunch catering, we mean business
      </h2>
      <p className="font-light text-gray-900 mt-6">
        We've worked with thousands of companies, large and small, to make lunch
        an experience the office will love. Whether you're feeding a small lunch
        meeting or the entire company, we'll get you options based on your
        dietary restrictions, preferences, and budget.
      </p>
      <p className="font-light text-gray-900 mt-3">
        Your local catering expert will take care of sourcing caterers in your
        area and manage the entire process. All you'll have to do is choose the
        best lunch options for your business and get ready to eat.
      </p>
    </div>
  )
}
function IntroGrid() {
  return (
    <OccasionPageGrid className="bg-white py-8">
      <OccasionPageGridRow
        heading="Fuel any Business Meeting"
        content="Ensure your corporate meetings are productive by keeping your employees well fed. Keep it healthy with chicken lettuce wraps or bring excitement with a mobile taco bar."
        image={lunchCatering1}
      />
      <OccasionPageGridRow
        heading="Impress Your Clients"
        content="The fastest way to their heart is through their stomach. Lobster rolls or sushi are a guarantee you're walking away with the sale."
        image={lunchCatering2}
        reverse
      />
    </OccasionPageGrid>
  )
}

function WhyWorkWithUsGrid() {
  return (
    <OccasionPageGrid className="bg-white py-8">
      <OccasionPageGridRow
        heading="Keep the Energy Up"
        content="Get your team fired up with a mobile coffee bar during your business lunch to help power them through the rest of the day."
        image={lunchCatering3}
      />
      <OccasionPageGridRow
        heading="Transform your Meeting"
        content="No matter how the day is going, your lunch will leave you feeling satisfied and ready to tackle the rest of the afternoon."
        image={lunchCatering4}
        reverse
      />
    </OccasionPageGrid>
  )
}
